import { useQuery } from '@tanstack/react-query'
import api from '../../config/axios-config'
import { authQueryKeys } from '../constants'

export const useIdpListQuery = (options) => {
  const authIdpList = async () => {
    const config = {
      method: 'get'
    }

    const { data } = await api('/api/saml/idps', config)

    return data
  }

  return useQuery({
    queryKey: [authQueryKeys.IDP_LIST],
    queryFn: () => authIdpList(),
    ...options
  })
}
